/**
 * Curated emoji offered by `EmojiPickerMenu` — used for both comment reactions
 * (CommentList) and the composer's emoji inserter (CommentComposer). A small
 * set — no emoji-picker dependency; a full searchable picker is a follow-up.
 */
export const QUICK_REACTIONS = ['👍', '❤️', '😄', '🎉', '😮', '👀'];
